import { Fragment } from 'react'
import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { PageHero } from '../components/PageHero'
import { Plate } from '../components/Plate'
import { copy, contactSubjects } from '../content/copy'
import { company, offices } from '../content/company'

const field = s('padding:14px 15px;border:1px solid #C3C9D1;background:#FFFFFF;font-size:14.5px;outline:none;')
const pair = s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,200px),1fr));gap:12px;')

export function Contact() {
  return (
    <div>
      <PageHero eyebrow="Contact" title={copy.contact.headline} />

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,72px) clamp(18px,4vw,32px);')}>
        <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,250px),1fr));gap:1px;background:#DCE0E5;border:1px solid #DCE0E5;')}>
          {offices.map((o, i) => (
            <div key={i} style={s('background:#F2F4F6;padding:clamp(18px,4vw,32px) 28px;')}>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#A8500F;")}>{o.tag}</div>
              <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:22px;margin:14px 0 14px;')}>{o.city}</h2>
              <div style={s('font-size:14.5px;line-height:1.75;color:#566070;')}>{o.address}</div>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:12.5px;line-height:1.9;color:#1B2430;margin-top:14px;")}>
                {o.phone}
                <br />
                {o.email}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section style={s('max-width:1320px;margin:0 auto;padding:0 clamp(18px,4vw,32px) 100px;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,320px),1fr));gap:clamp(36px,4vw,64px);align-items:start;')}>
        <div>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(24px,3vw,32px);letter-spacing:-0.025em;margin:0 0 12px;')}>Send us a message</h2>
          <p style={s('font-size:16px;line-height:1.65;color:#566070;margin:0 0 28px;')}>
            {copy.contact.formBlurbBefore}
            <A href="/quote" style={s('border-bottom:1px solid #A8500F;')}>
              {copy.contact.formBlurbLink}
            </A>
            {copy.contact.formBlurbAfter}
          </p>
          {/* Not wired to a backend — see README.md § Forms. */}
          <div style={s('display:flex;flex-direction:column;gap:12px;')}>
            <div style={pair}>
              <input placeholder="Full name" aria-label="Full name" style={field} />
              <input placeholder="Company" aria-label="Company" style={field} />
            </div>
            <div style={pair}>
              <input placeholder="Email address" type="email" aria-label="Email address" style={field} />
              <input placeholder="Phone" aria-label="Phone" style={field} />
            </div>
            <select aria-label="Subject" style={s('padding:14px 15px;border:1px solid #C3C9D1;background:#FFFFFF;font-size:14.5px;outline:none;color:#566070;')} defaultValue={contactSubjects[0]}>
              {contactSubjects.map((o) => (
                <option key={o}>{o}</option>
              ))}
            </select>
            <textarea placeholder="How can we help?" aria-label="Message" rows={6} style={s('padding:14px 15px;border:1px solid #C3C9D1;background:#FFFFFF;font-size:14.5px;outline:none;resize:vertical;')} />
            <button style={s('background:#1B2430;color:#F2F4F6;border:0;padding:16px;font-size:14px;font-weight:600;cursor:pointer;align-self:flex-start;padding-left:36px;padding-right:36px;')} className={h('background:#1F5C99;')}>
              Send message
            </button>
          </div>
        </div>

        <div>
          <Plate box="aspect-ratio:1/1;display:flex;align-items:flex-end;padding:18px;" caption="map — burgersfort" captionStyle="padding:6px 10px;border-left:2px solid #1F5C99;" />
          <div style={s('background:#1B2430;color:#B8C0CA;padding:30px 28px;margin-top:1px;')}>
            <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#E06A20;margin-bottom:14px;")}>Office hours</div>
            <div style={s('font-size:15px;line-height:1.9;')}>
              {company.officeHours.map((line, i) => (
                <Fragment key={i}>
                  {i > 0 && <br />}
                  {line}
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
